module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p4"
  }, [_c('i')]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i')]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("The water says:")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("I remember.")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("I came first of all.")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("There was nothing before me.")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i')]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("In the time of rain")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("rain fell on the water.")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("In the time of dryness")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("the water reflected the sky.")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i')]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("I came first of all.")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("There was nothing before me.")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i')]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("Vapor rose.")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("It became")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("the tree of heaven.")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i')]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("Vapor rose.")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("It became")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("the bird of the sun.")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i')]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("A seed fell.")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("The earth began growing.")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("Animals sprang up.")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("The vegetation was thick.")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i')]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("Then came the people.")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("Then came the spirits")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("and the powerful demons")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("who live under the earth.")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i')]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("Let me tell you:")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("I will outlast them.")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i')]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("Even the demons")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("will disappear in time.")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i')]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("I have no shape.")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("No one can divide me.")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("No one can say")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('i', [_vm._v("what I really am.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('b')]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }), _vm._v(" "), _c('p', {
    staticClass: "p3"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40893a6b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/section4.vue
// module id = 90
// module chunks = 0